import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCaretDown,
  faCaretUp,
  faFileSignature,
  faListOl,
  faLock,
  faMinus,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import UsedInBadge from "../UsedInBadge";
import HelpButton from "../../../HelpContent/HelpButton";
import {
  deleteInputArgument,
  deleteVariableGroup,
  moveVariableGroup,
  moveVariableGroupDown,
  moveVariableGroupUp,
  selectInputArguments,
  selectVariableGroups,
} from "../../../store/slices/projectSlice";
import { setCurrentModal } from "../../../store/slices/modalsSlice";

export default function VariableGroups() {
  const variableGroups = useSelector(selectVariableGroups);
  const inputArguments = useSelector(selectInputArguments);
  const dispatch = useDispatch();
  const [dragTarget, setDragTarget] = useState();
  const [dragging, setDragging] = useState(false);

  return (
    <div className="mt-2 card">
      <div className="card-header m-0 p-2 d-flex align-items-start">
        <h5 className="card-title">Variable groups</h5>
        <HelpButton helpKey="variable-groups" />
        <div className="flex-grow-1" />
        <button
          type="button"
          onClick={() => {
            dispatch(
              setCurrentModal({
                modal: "variableGroup",
                tab: "create",
                data: { variableGroupUUID: "create_new" },
              })
            );
          }}
          className="btn btn-outline-primary btn-sm border-0"
        >
          <FontAwesomeIcon icon={faPlus} />
        </button>
      </div>
      <div className="card-body p-0">
        {variableGroups.length > 0 ? (
          <ul className="list-group list-group-flush">
            {[...variableGroups]
              .sort((a, b) => a.Order - b.Order)
              .map((variable, index) => (
                <li
                  key={variable.GroupUuid}
                  className="list-group-item p-0"
                  draggable
                  onDragOver={(e) => {
                    e.preventDefault();
                    if (dragging) {
                      setDragTarget(index);
                    }
                  }}
                  onDragEnd={(e) => {
                    if (
                      dragging &&
                      dragTarget !== undefined &&
                      dragTarget !== index
                    ) {
                      dispatch(
                        moveVariableGroup({
                          sourceIndex: index,
                          destinationIndex: dragTarget,
                        })
                      );
                    }
                    setDragTarget();
                    setDragging(false);
                  }}
                  onDragStart={() => setDragging(true)}
                >
                  {dragTarget === index && (
                    <div className="p-1 bg-purple-gradient"></div>
                  )}
                  <div
                    className={`m-0 py-1 px-2 d-flex justify-content-between align-items-center`}
                  >
                    <div className="m-0 me-2">
                      <button
                        className="btn d-block p-0 px-1 btn-outline-secondary border-0 mb-n2"
                        onClick={() => {
                          dispatch(moveVariableGroupUp(variable.GroupUuid));
                        }}
                        disabled={index === 0}
                      >
                        <FontAwesomeIcon icon={faCaretUp} />
                      </button>
                      <button
                        className="btn d-block p-0 px-1 btn-outline-secondary border-0 mt-n2"
                        onClick={() => {
                          dispatch(moveVariableGroupDown(variable.GroupUuid));
                        }}
                        disabled={index === variableGroups.length - 1}
                      >
                        <FontAwesomeIcon icon={faCaretDown} />
                      </button>
                    </div>
                    <button
                      type="button"
                      onClick={() => {
                        dispatch(
                          setCurrentModal({
                            modal: "variableGroup",
                            tab: "create",
                            data: { variableGroupUUID: variable.GroupUuid },
                          })
                        );
                      }}
                      className="btn btn-link text-start p-0"
                    >
                      {variable.Label}{" "}
                    </button>
                    <div className="ms-auto">
                      {inputArguments.some(
                        (ia) => ia.GroupUuid === variable.GroupUuid
                      ) ? (
                        <span
                          className="badge bg-secondary"
                          title="Used in input arguments"
                        >
                          {
                            inputArguments.filter(
                              (ia) => ia.GroupUuid === variable.GroupUuid
                            ).length
                          }
                        </span>
                      ) : (
                        <button
                          type="button"
                          title="Delete argument"
                          className="btn btn-outline-danger btn-sm border-0 px-1"
                          style={{ width: 22 }}
                          onClick={() =>
                            dispatch(deleteVariableGroup(variable.GroupUuid))
                          }
                        >
                          <FontAwesomeIcon icon={faMinus} />
                        </button>
                      )}
                    </div>{" "}
                  </div>
                </li>
              ))}
          </ul>
        ) : (
          <div className="text-center m-1">No input arguments</div>
        )}
      </div>
    </div>
  );
}
